import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'providers/wonde/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('wonde/', '')
      .toLowerCase();
  }
}
